import React from "react";

// Listă de rânduri de text (atribuții etc.): adăugare, ștergere, mutare sus/jos. `rows` = textarea pe rând, altfel input.
export default function ListEditor({ value, onChange, placeholder, rows = 0, addLabel = "+ Adaugă rând", testid, extraActions, readOnly }) {
  const set = (i, v) => onChange(value.map((x, j) => j === i ? v : x));
  const move = (i, d) => { const j = i + d; if (j < 0 || j >= value.length) return; const a = [...value]; [a[i], a[j]] = [a[j], a[i]]; onChange(a); };
  return (
    <div data-testid={testid}>
      {value.map((v, i) => (
        <div key={i} style={{ display: "flex", gap: 6, alignItems: "flex-start", marginBottom: 6 }}>
          <div style={{ minWidth: 24, paddingTop: 8, fontSize: 12, color: "#64748B", textAlign: "right" }}>{i + 1}.</div>
          {rows ? <textarea className="textarea" rows={rows} value={v} placeholder={placeholder} onChange={e => set(i, e.target.value)} style={{ flex: 1 }} />
                : <input className="input" value={v} placeholder={placeholder} onChange={e => set(i, e.target.value)} style={{ flex: 1 }} />}
          {!readOnly && <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <button type="button" className="btn btn-secondary" style={{ padding: "0 7px", fontSize: 11, minHeight: 0 }} onClick={() => move(i, -1)} title="Mută în sus">↑</button>
            <button type="button" className="btn btn-secondary" style={{ padding: "0 7px", fontSize: 11, minHeight: 0 }} onClick={() => move(i, 1)} title="Mută în jos">↓</button>
          </div>}
          {!readOnly && <button type="button" className="btn btn-secondary" style={{ padding: "3px 9px", color: "#B91C1C" }} onClick={() => onChange(value.filter((_, j) => j !== i))} title="Șterge">✕</button>}
        </div>
      ))}
      {!readOnly && <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button type="button" className="btn btn-secondary" onClick={() => onChange([...value, ""])} data-testid={testid ? `${testid}-add` : undefined}>{addLabel}</button>
        {extraActions}
      </div>}
    </div>
  );
}
